module.exports = __webpack_public_path__ + "img/icon_modechoose_other.62460e9a.png";